module.exports = __webpack_public_path__ + "static/img/img.2fd8d7c7.jpg";